import styled, { css } from 'styled-components';

export const StyledTable = styled.table.withConfig({
    shouldForwardProp: prop => !['variant', 'headerFontSize', 'cellFontSize', 'hasBorders'].includes(prop),
})<{
    variant?: 'simple' | 'striped' | 'unstyled' | 'dense';
    headerFontSize: string | number;
    cellFontSize: string | number;
    hasBorders: boolean;
}>`
    width: 100%;
    border-collapse: ${({ hasBorders }) => (hasBorders ? 'separate' : 'collapse')};
    border-spacing: 0;
    border: ${({ theme, hasBorders }) => hasBorders && `1px solid ${theme.gray8}`};
    border-radius: ${({ hasBorders }) => hasBorders && '8px'};
    font-style: normal;
    margin-bottom: 20px;

    th {
        color: ${({ theme }) => theme.gray4};
        font-size: ${({ headerFontSize }) =>
            typeof headerFontSize === 'number' ? `${headerFontSize}px` : headerFontSize};
        font-weight: 600;
        padding: 8px;
    }

    td {
        color: ${({ theme }) => theme.gray2};
        font-size: ${({ cellFontSize }) => (typeof cellFontSize === 'number' ? `${cellFontSize}px` : cellFontSize)};
        font-weight: 400;
        line-height: 20px;
        padding: 8px;
    }

    /* Variant styles */
    ${({ variant }) => {
        switch (variant) {
            case 'striped':
                return css`
                    tbody tr:nth-of-type(odd) {
                        background-color: ${({ theme }) => theme.gray10};
                    }
                `;
            case 'simple':
                return css`
                    border-radius: 8px;
                    th,
                    td {
                        border-bottom: 1px solid ${({ theme }) => theme.gray8};
                    }
                    th {
                        background-color: ${({ theme }) => theme.gray11};
                    }
                `;
            case 'unstyled':
                return css`
                    th,
                    td {
                        border: none;
                        color: ${({ theme }) => theme.gray2};
                    }
                `;
            case 'dense':
                return css`
                    th,
                    td {
                        word-break: break-all;
                    }
                `;
            default:
                return '';
        }
    }}
`;
